import { SET_CURRENT_IMAGE_UPLOAD } from "./imageConstants";
import { setValue } from "../../lib/immutable_wrapper";

const initialState = {
    image: null,
};

export function image(state = initialState, action) {
    switch (action.type) {
        case SET_CURRENT_IMAGE_UPLOAD:
            return setValue(state, ["image"], action.image);
        default:
            return state;
    }
}
